module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.sideMenu) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "md3": "",
      "lg3": "",
      "xl2": ""
    }
  }, [_c('v-card', {
    attrs: {
      "tile": "",
      "dark": "",
      "height": "100%"
    }
  }, [_c('v-tabs', {
    attrs: {
      "grow": "",
      "dark": ""
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab', {
    on: {
      "click": function($event) {
        _vm.monthView = true
      }
    }
  }, [_vm._v("Month view")]), _vm._v(" "), _c('v-tab', {
    on: {
      "click": function($event) {
        _vm.monthView = false
      }
    }
  }, [_vm._v("Side by side")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.date) ? _c('v-date-picker', {
    staticClass: "elevation-0",
    attrs: {
      "full-width": "",
      "type": _vm.pickerMode
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.monthView) ? _c('v-switch', {
    staticClass: "mx-3 my-0",
    attrs: {
      "label": "Hide weekends",
      "dense": ""
    },
    model: {
      value: (_vm.hideWeekends),
      callback: function($$v) {
        _vm.hideWeekends = $$v
      },
      expression: "hideWeekends"
    }
  }) : _vm._e(), _vm._v(" "), [_c('v-subheader', {
    staticClass: "overline my-0"
  }, [_vm._v("Calendars")]), _vm._v(" "), _c('v-list', [_vm._l((_vm.colleagues), function(practitioner, practitionerId) {
    return [_c('practitioner-list-item', {
      key: practitionerId,
      attrs: {
        "with-avatar": true,
        "item": practitioner
      },
      on: {
        "selected": function($event) {
          return _vm.setSelected(practitioner)
        }
      }
    }, [_c('template', {
      slot: "action"
    }, [_c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "small": "",
        "outline": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.newAppointment(practitioner)
        }
      }
    }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [(practitioner.id in _vm.selectedPractitioners) ? _c('v-icon', {
      attrs: {
        "color": practitioner.color
      }
    }, [_vm._v("check_box")]) : _c('v-icon', {
      attrs: {
        "color": practitioner.color
      }
    }, [_vm._v("check_box_outline_blank")])], 1)], 1)], 2), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (practitioner.id))
    })]
  })], 2)], _vm._v(" "), (_vm.getSharedCalendars && _vm.getSharedCalendars.length > 0) ? [_c('v-subheader', {
    staticClass: "overline my-0"
  }, [_vm._v("Shared\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": "",
      "loading": _vm.getLookupsRequest.loading
    },
    on: {
      "click": _vm.getLookups
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1)], 1), _vm._v(" "), _c('v-list', _vm._l((_vm.getSharedCalendars), function(cal) {
    return _c('v-list-tile', {
      key: cal.id
    }, [_c('v-list-tile-content', [_c('v-checkbox', {
      attrs: {
        "hide-details": "",
        "label": cal.title,
        "value": cal.id
      },
      model: {
        value: (_vm.visibleSharedCalendarIds),
        callback: function($$v) {
          _vm.visibleSharedCalendarIds = $$v
        },
        expression: "visibleSharedCalendarIds"
      }
    })], 1)], 1)
  }), 1)] : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('invite-btn', {
    attrs: {
      "attrs": {
        block: true
      }
    }
  })], 1)], 2)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": _vm.sideMenu,
      "md9": _vm.sideMenu,
      "lg9": _vm.sideMenu,
      "xl10": _vm.sideMenu
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": "",
      "dark": ""
    }
  }, [_c('v-toolbar-side-icon', [_c('v-btn', {
    attrs: {
      "icon": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.sideMenu = !_vm.sideMenu
      }
    }
  }, [_c('v-icon', [_vm._v("menu")])], 1)], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.monthrequest.loading,
      "icon": "",
      "flat": "",
      "small": ""
    },
    on: {
      "click": _vm.update
    }
  }, [_c('v-icon', [_vm._v("replay")])], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.dateFormatted))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('space-and-location-picker', {
    on: {
      "input": _vm.setFilters
    }
  }), _vm._v(" "), (_vm.monthView) ? _c('search-field', {
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.monthView) ? [_c('v-flex', [_c('v-card', {
    attrs: {
      "tile": "",
      "height": "100%"
    }
  }, [_c('request-status', {
    attrs: {
      "request": _vm.monthrequest,
      "message200": false
    }
  }), _vm._v(" "), _c('v-calendar', {
    attrs: {
      "value": _vm.startDate,
      "events": _vm.$store.getters.getEventRange,
      "type": _vm.monthViewType,
      "weekdays": _vm.weekdays
    },
    on: {
      "click:date": _vm.zoomIn,
      "click:day": _vm.dayClicked
    },
    scopedSlots: _vm._u([{
      key: "day",
      fn: function(ref) {
        var date = ref.date;

        return [_vm._l((_vm.getEvents(date)), function(event) {
          return [(event.id && _vm.ignoredStatuses.indexOf(event.status)) ? _c('v-chip', {
            key: event.id,
            staticClass: "v-chip--x-small ma-0",
            staticStyle: {
              "width": "100%"
            },
            attrs: {
              "color": _vm.colleagues[event.practitioner].color,
              "outline": "",
              "block": ""
            },
            on: {
              "click": [function($event) {
                if (!$event.metaKey) { return null; }
                $event.stopPropagation();
                return _vm.setSelectedAppointments(event)
              }, function($event) {
                if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
                $event.stopPropagation();
                return _vm.setSelectedAppointment(event)
              }]
            }
          }, [_c('v-avatar', {
            staticClass: "mr-1",
            staticStyle: {
              "max-width": "16px!important",
              "max-height": "16px!important",
              "min-width": "16px!important",
              "min-height": "16px!important"
            }
          }, [(_vm.isSelected(event)) ? _c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("check")]) : _c('img', {
            attrs: {
              "src": _vm.colleagues[event.practitioner].profile_picture
            }
          })], 1), _vm._v("\n                  " + _vm._s(event.title) + "\n                  "), _c('small', {
            staticStyle: {
              "position": "absolute",
              "right": "5px"
            }
          }, [_vm._v(_vm._s(event.start))])], 1) : _vm._e()]
        })]
      }
    }, {
      key: "interval",
      fn: function(ref) {
        var date = ref.date;
        var hour = ref.hour;

        return [_vm._l((_vm.getEventsByHour(date, hour)), function(event) {
          return [_c('interval-slot', {
            key: ((event.id) + "-" + date + "-" + hour),
            attrs: {
              "flat": "",
              "small": "",
              "color": _vm.colleagues[event.practitioner].color,
              "events": _vm.getEvents(date),
              "event": event
            }
          })]
        })]
      }
    }], null, false, 4110408284)
  })], 1)], 1)] : _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.selectedPractitioners), function(practitioner) {
    return _c('v-flex', {
      key: practitioner.id,
      class: _vm.flexSize
    }, [(_vm.date) ? _c('practitioner-day-view', {
      attrs: {
        "with-title": "",
        "with-add": "",
        "with-fetch": "",
        "practitioner": practitioner,
        "filter-spaces": _vm.filterSpaces,
        "filter-locations": _vm.filterLocations,
        "touch": _vm.dayViewTouch,
        "date": _vm.date
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.visibleSharedCalendars && _vm.visibleSharedCalendars.length > 0) ? _vm._l((_vm.visibleSharedCalendars), function(cal) {
    return _c('v-flex', {
      key: cal.id,
      class: _vm.flexSize
    }, [(_vm.date) ? _c('shared-calendar-day-view', {
      attrs: {
        "with-title": "",
        "with-add": "",
        "calendar-id": cal.id,
        "title": cal.title,
        "date": _vm.date
      }
    }) : _vm._e()], 1)
  }) : _vm._e()], 2)], 2), _vm._v(" "), _c('appointment-bottom-sheet', {
    attrs: {
      "appointment": _vm.selectedEvent,
      "readOnly": _vm.readOnly
    },
    model: {
      value: (_vm.bottomsheet),
      callback: function($$v) {
        _vm.bottomsheet = $$v
      },
      expression: "bottomsheet"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "420"
    },
    model: {
      value: (_vm.addTeamMember),
      callback: function($$v) {
        _vm.addTeamMember = $$v
      },
      expression: "addTeamMember"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "overline"
  }, [_vm._v("\n        Coming soon\n      ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        This functionality is not yet available. To add a team member, please\n        "), _c('a', {
    attrs: {
      "href": "mailto:support@appointmentguru.co"
    }
  }, [_vm._v("contact support")]), _vm._v(".\n        Please note that there is an additional cost of R150/month for each additional team member\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.addTeamMember = false
      }
    }
  }, [_vm._v("Got it")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21b1ed38","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/TeamView.vue
// module id = 1649
// module chunks = 3